import api from './api';
import { Program } from '../types/program';

interface PaginatedResponse<T> {
    data: T[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

interface CombinedResponse {
    programs: Program[];
    categories: Program[];
    totalPrograms: number;
    totalCategories: number;
    page: number;
    limit: number;
    totalPages: number;
}

export const getWorkoutPrograms = async (page: number = 1, limit: number = 10): Promise<PaginatedResponse<Program>> => {
    const response = await api.get<PaginatedResponse<Program>>('/workout-programs', {
        params: { page, limit },
    });
    return response.data;
};

export const getWorkoutCategories = async (page: number = 1, limit: number = 10): Promise<PaginatedResponse<Program>> => {
    const response = await api.get<PaginatedResponse<Program>>('/workout-categories', {
        params: { page, limit },
    });
    return response.data;
};

export const deleteWorkoutProgram = async (programId: number) => {
    const response = await api.delete(`/workout-programs/${programId}`);
    return response.data;
};

export const deleteWorkoutCategory = async (categoryId: number) => {
    const response = await api.delete(`/workout-categories/${categoryId}`);
    return response.data;
};

export const updateWorkoutProgram = async (
    id: number,
    data: { title: string; description: string; imageUrl: string }
): Promise<void> => {
    await api.put(`/workout-programs/${id}`, data);
};

export const updateWorkoutCategory = async (
    id: number,
    data: { title: string; description: string; imageUrl: string }
): Promise<void> => {
    await api.put(`/workout-categories/${id}`, data);
};

export const createWorkoutProgram = async (program: {
    title: string;
    imageUrl: string;
    trainerImage: string | null;
    trainer: string;
}): Promise<Program> => {
    console.log("Program", program);

    const response = await api.post<Program>('/workout-programs', program);
    console.log(response.data);

    return response.data;
};

export const createWorkoutCategory = async (category: {
    title: string;
    imageUrl: string;
    trainerImage: string | null;
    trainer: string;
}): Promise<Program> => {
    const response = await api.post<Program>('/workout-categories', category);
    console.log(response.data);

    return response.data;
};

export const getCombinedWorkouts = async (
    page: number = 1,
    limit: number = 10
): Promise<CombinedResponse> => {
    const response = await api.get<CombinedResponse>('/combined-workouts', {
        params: { page, limit },
    });
    return response.data;
};
